<template>
  <div class="loading" :class="{show: isLoad}">
    <div class="loading_icon">
      <img src="@/assets/images/loading.png"/>
    </div>
  </div>
</template>

<style scoped>
  .loading {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 3.75rem;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0);
    position: fixed;
    z-index: 3000;
    top: 0;
  }
  .loading.show {
    display: flex;
  }
  .loading .loading_icon {
    display: flex;
    width: 1.2rem;
    height: 1.2rem;
    background-color: rgba(0, 0, 0, 0.75);
    justify-content: center;
    align-items: center;
    border-radius: 8px;
  }
  .loading .loading_icon img {
    width: 0.44rem;
    height: 0.44rem;
    animation: turn 3s linear infinite; 
  }
  @keyframes turn {
    0%{-webkit-transform:rotate(0deg);}
    25%{-webkit-transform:rotate(90deg);}
    50%{-webkit-transform:rotate(180deg);}
    75%{-webkit-transform:rotate(270deg);}
    100%{-webkit-transform:rotate(360deg);}
  }
</style>

<script>
export default {
  props: {
    isLoad: {
      type: Boolean,
      default: false
    }
  }
}
</script>

